<template>
    <div>
      <el-form label-width="68px" class="demo-ruleForm">
         <el-form-item  label="选择平台" prop="name">
            <SelectBlock ref="platform"   keyVal="platform" title="" left="0" value="" @getVal="getVal" :options="options"  placeholder="请选者平台"></SelectBlock>
         </el-form-item>
      </el-form>
      <!--表格-->
      <div class="warp-table">
         <el-table ref="giftTable" :data="tableData" size="medium" style="width: 100%"  row-key="id" border  :max-height="280" lazy  :tree-props="{children: 'childMBs', hasChildren: 'hasChildren'}">
            <el-table-column  prop="name"    label="系统模块功能" width="200">
                <template slot-scope="scope">
                   <div class="common-items-center">
                       <el-checkbox v-model="scope.row.mark" @change="selectVal(scope.row)"/>
                       <span class="nameTitle">{{scope.row.name}}</span>
                   </div>
                </template>
            </el-table-column>
            <el-table-column  prop="childMBs" label="功能操作按钮">
               <template slot-scope="scope">
                  <div class="common-items-center">
                     <div class="common-items-center" style="margin-right:10px" v-for="(item,index) in scope.row.btnList">
                        <el-checkbox v-model="item.mark" @change="selectVal(item)"/>
                        <span class="nameTitle">{{item.name}}</span>
                     </div>
                  </div>
                </template>
            </el-table-column>
         </el-table>
      </div>
    </div>
</template>
<script>
import { scroll } from '../../../../components/component-mixin/block-scroll';
import { postFun } from '@/utils/httpFun';
import { operate,userApi } from '@/utils/config'
import { arraySort } from '@/utils/util'
  export default {
   data:()=>({
      platformID:0,
      checked:true,
      menuButtonIds:[],
      tableData: [],
   }),
   mixins:[scroll],
   props:{
        options:{
           type:Array,
           default:()=>([])
        },
        val:{
           type:Array,
           default:()=>([])
        },
        keyVal:{
           type:String,
           default: "key",
        }
   },
   methods:{

      //页面初始化时得到的值
      initialize(ev){
         this.platformID = ev.indexNo
         this.$refs.platform.setVal(ev.selectName)
         this.menuButtonIds = this.val
         console.log("你好")
         this.getData() 
      },

      //获取选中平台的值
      getVal(ev){
         this.platformID = ev.indexNo
         this.getData() 
      },
      
      //获取对应平台的数据
      async getData(){
         let parms = {
            id:0,                         //0根节点
            subsystemId:this.platformID   //平台id
         }
         await postFun(operate.MODULETREE,parms,res=>{
            this.changeKay(res.data)
         })
      },

      //选中值
      selectVal(ev){
         if(ev.mark){
           this.menuButtonIds = arraySort([...this.menuButtonIds,...[ev.id]])
         }else{
           let no =  this.menuButtonIds.indexOf(ev.id)
           this.menuButtonIds.splice(no,1)
         }
          let parms = {
              key:this.keyVal,
              val:this.menuButtonIds
          }
          this.$emit("getVal",parms)
      },

      //处理数据结构 
      changeKay(objAry) {
         if (objAry != null) {
             objAry.forEach((item) => {
               if(this.menuButtonIds.length!=0){
                  for(var i in this.menuButtonIds){
                    if(this.menuButtonIds[i]*1 == item.id){
                       item["mark"] = true
                    }
                  }
               }else{
                  item["mark"] = false
               }
               item["btnList"] = []
               let childMBs = item.childMBs
                   if(childMBs!=undefined){
                      childMBs.forEach((itemChild,index)=>{
                        if(itemChild.type==2){
                           for(var i in this.menuButtonIds){
                              if(this.menuButtonIds[i]*1 == itemChild.id){
                                 itemChild["mark"] = true
                              }
                           }
                           item["btnList"].push(itemChild)
                        }else{
                           this.changeKay(item.childMBs);
                        }
                     })
                  }
            });
         }
         this.tableData = objAry
      }
   }
  }
</script>






<style scoped lang="scss">
  .warp-table{
     max-height: 280px;
     overflow-y: auto;
     ::v-deep .cell{
       display: flex;
     }
     .nameTitle{
       margin-left: 5px;
     }
  }
</style>